
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-first_page",
  "use": "icon-material-first_page-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-first_page\"><path d=\"M235.93-234.26v-491.48h68.14v491.48zm451.07-3L447.26-477 687-716.74 735.74-668l-191 191 191 191z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-first_page"/>
                </svg>
            );
        };

        Icon.id = "icon-material-first_page";

        export default Icon;
    